<template>
	<div id="web-page">
        <AppHeader />
		<router-view />
        <AppFooter />
	</div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";

export default {
    components: {
        AppHeader,
        AppFooter
    },
    mounted() {
        this.loadFacebookPixel();
        this.loadHotjarTrackingCode();
        this.loadIntercom();
    },
    methods: {
        loadFacebookPixel() {
            /* eslint-disable */
            !(function(f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function() {
                    n.callMethod
                        ? n.callMethod.apply(n, arguments)
                        : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = "2.0";
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(
                window,
                document,
                "script",
                "https://connect.facebook.net/en_US/fbevents.js"
            );
            window.fbq("init", process.env.VUE_APP_FACEBOOK_ID);
            window.fbq("track", "PageView");
        },
        loadHotjarTrackingCode() {
            // Hotjar Tracking Code for http://localhost:8080/
            /* eslint-disable */
            (function(h,o,t,j,a,r) {
                h.hj = h.hj || function() {
                    (h.hj.q=h.hj.q||[]).push(arguments)
                };
                h._hjSettings = { hjid: 1294253, hjsv: 6 };
                a = o.getElementsByTagName("head")[0];
                r = o.createElement("script");
                r.async = 1;
                r.src= t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,"https://static.hotjar.com/c/hotjar-",".js?sv=");
        },
        loadIntercom() {
            const APP_ID = window.APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;
            const intercomSettings = window.intercomSettings = {
                app_id: APP_ID
            };

            /* eslint-disable */
            (function(){
                var w = window;
                var ic = w.Intercom;
                if (typeof ic === "function") {
                    ic("reattach_activator");
                    ic("update", intercomSettings);
                } else {
                    var d = document;
                    var i = function() {
                        i.c(arguments)
                    };
                    i.q = [];
                    i.c = function(args) {
                        i.q.push(args)
                    };
                    w.Intercom = i;
                    function l() {
                        console.log(APP_ID);
                        var s = d.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = `https://widget.intercom.io/widget/${APP_ID}`;
                        var x = d.getElementsByTagName("script")[0];
                        x.parentNode.insertBefore(s, x);
                    }
                    if(w.attachEvent) {
                        w.attachEvent("onload", l);
                    } else{
                        w.addEventListener("load", l, false);
                    }
                }
            })();

            window.Intercom("boot", {
                app_id: APP_ID
            });
        }
    }
};
</script>

<style lang="scss">
    @import "~bootstrap/dist/css/bootstrap.min.css";
    @import "@/assets/scss/stylesheet.scss";

	[data-scroll-class] {
		opacity: 0;
	}
    .animated {
        opacity: 1;
    }
</style>